import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = { class: "h-100 g-wizard-control container-fluid" };
const _hoisted_2 = { class: "row h-100" };
const _hoisted_3 = { class: "col-4 h-100 bg-light border-end overflow-auto p-3 d-flex flex-column gap-3" };
const _hoisted_4 = { class: "col-8 p-0 m-0" };
const _hoisted_5 = { class: "h-100 d-flex flex-column" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_wizard_header = _resolveComponent("g-wizard-header");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx._pages, (page, index) => {
                    return (_openBlock(), _createBlock(_component_g_wizard_header, {
                        page: page,
                        index: index,
                        "is-active": "isActivePage(page.name)",
                        key: page.title
                    }, null, 8, ["page", "index"]));
                }), 128))
            ]),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _renderSlot(_ctx.$slots, "default")
                ])
            ])
        ])
    ]));
}
